import React, { useState, useMemo } from "react";
import { Search, Pencil, Trash2, ShoppingCart, CreditCard, X, Check } from "lucide-react";

// Define common type for products and services
interface POSItem {
  id: string;
  name: string;
  category: string;
  price: number;
  image: string | null;
}

// Aesthetics-specific products and services
const aestheticsProducts: POSItem[] = [
  // Skincare Products
  { id: "p1", name: "Hyaluronic Acid Serum", category: "Skincare", price: 45.00, image: "https://images.unsplash.com/photo-1620916566398-39f1143ab7be?w=200&h=200&fit=crop" },
  { id: "p2", name: "Vitamin C Brightening Cream", category: "Skincare", price: 55.00, image: "https://images.unsplash.com/photo-1611930022073-b7a4ba5fcccd?w=200&h=200&fit=crop" },
  { id: "p3", name: "Retinol Night Cream", category: "Skincare", price: 65.00, image: "https://images.unsplash.com/photo-1570194065650-d99fb4b38b17?w=200&h=200&fit=crop" },
  { id: "p4", name: "SPF 50 Sunscreen", category: "Skincare", price: 35.00, image: "https://images.unsplash.com/photo-1556228720-195a672e8a03?w=200&h=200&fit=crop" },
  { id: "p5", name: "Niacinamide Serum", category: "Skincare", price: 40.00, image: "https://images.unsplash.com/photo-1608248543803-ba4f8c70ae0b?w=200&h=200&fit=crop" },
  { id: "p6", name: "Peptide Eye Cream", category: "Skincare", price: 48.00, image: "https://images.unsplash.com/photo-1596755389378-c31d21fd1273?w=200&h=200&fit=crop" },
  
  // Lip Care
  { id: "p7", name: "Lip Repair Balm", category: "Lip Care", price: 18.00, image: "https://images.unsplash.com/photo-1586495777744-4413f21062fa?w=200&h=200&fit=crop" },
  { id: "p8", name: "Lip Plumping Gloss", category: "Lip Care", price: 25.00, image: "https://images.unsplash.com/photo-1631214503851-68eb7c70e1a5?w=200&h=200&fit=crop" },
  
  // Aftercare Products
  { id: "p9", name: "Post-Treatment Soothing Gel", category: "Aftercare", price: 28.00, image: "https://images.unsplash.com/photo-1556228578-0d85b1a4d571?w=200&h=200&fit=crop" },
  { id: "p10", name: "Arnica Bruise Cream", category: "Aftercare", price: 22.00, image: "https://images.unsplash.com/photo-1601049541289-9b1b7bbbfe19?w=200&h=200&fit=crop" },
  { id: "p11", name: "Healing Recovery Mask", category: "Aftercare", price: 32.00, image: "https://images.unsplash.com/photo-1567721913486-6585f069b332?w=200&h=200&fit=crop" },
  
  // Professional Products
  { id: "p12", name: "Clinical Cleanser 500ml", category: "Professional", price: 85.00, image: "https://images.unsplash.com/photo-1556228453-efd6c1ff04f6?w=200&h=200&fit=crop" },
  { id: "p13", name: "Medical Grade Moisturizer", category: "Professional", price: 95.00, image: "https://images.unsplash.com/photo-1612817288484-6f916006741a?w=200&h=200&fit=crop" },
  { id: "p14", name: "Numbing Cream 30g", category: "Professional", price: 45.00, image: "https://images.unsplash.com/photo-1583209814683-c023dd293cc6?w=200&h=200&fit=crop" },
  
  // Gift Sets
  { id: "p15", name: "Luxury Skincare Gift Set", category: "Gift Sets", price: 150.00, image: "https://images.unsplash.com/photo-1522335789203-aabd1fc54bc9?w=200&h=200&fit=crop" },
  { id: "p16", name: "Anti-Aging Starter Kit", category: "Gift Sets", price: 120.00, image: "https://images.unsplash.com/photo-1571781926291-c477ebfd024b?w=200&h=200&fit=crop" },
];

// Aesthetics services that can be sold
const aestheticsServices: POSItem[] = [
  { id: "s1", name: "Botox - Forehead", category: "Injectables", price: 250.00, image: null },
  { id: "s2", name: "Botox - Crow's Feet", category: "Injectables", price: 180.00, image: null },
  { id: "s3", name: "Botox - Frown Lines", category: "Injectables", price: 200.00, image: null },
  { id: "s4", name: "Lip Filler 0.5ml", category: "Dermal Fillers", price: 220.00, image: null },
  { id: "s5", name: "Lip Filler 1ml", category: "Dermal Fillers", price: 320.00, image: null },
  { id: "s6", name: "Cheek Filler 1ml", category: "Dermal Fillers", price: 350.00, image: null },
  { id: "s7", name: "Jawline Filler 2ml", category: "Dermal Fillers", price: 550.00, image: null },
  { id: "s8", name: "Hydrafacial - Classic", category: "Facials", price: 120.00, image: null },
  { id: "s9", name: "Hydrafacial - Deluxe", category: "Facials", price: 180.00, image: null },
  { id: "s10", name: "Chemical Peel - Light", category: "Peels", price: 95.00, image: null },
  { id: "s11", name: "Chemical Peel - Medium", category: "Peels", price: 150.00, image: null },
  { id: "s12", name: "Microneedling Session", category: "Skin Treatments", price: 200.00, image: null },
  { id: "s13", name: "PRP Facial", category: "Skin Treatments", price: 350.00, image: null },
  { id: "s14", name: "LED Light Therapy", category: "Skin Treatments", price: 65.00, image: null },
  { id: "s15", name: "Consultation", category: "Consultation", price: 50.00, image: null },
  { id: "s16", name: "Follow-up Appointment", category: "Consultation", price: 0.00, image: null },
];

interface CartItem {
  id: string;
  name: string;
  category: string;
  price: number;
  quantity: number;
  type: "product" | "service";
  image?: string | null;
}

const AestheticPOS: React.FC = () => {
  const currencySymbol = "£";
  const [cartItems, setCartItems] = useState<CartItem[]>([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [activeTab, setActiveTab] = useState<"products" | "services">("products");
  const [editingItem, setEditingItem] = useState<string | null>(null);
  const [editQuantity, setEditQuantity] = useState<number>(1);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState<"card" | "cash" | "split">("card");
  const [paymentComplete, setPaymentComplete] = useState(false);

  // Filter items based on search and active tab
  const filteredItems = useMemo(() => {
    const items = activeTab === "products" ? aestheticsProducts : aestheticsServices;
    if (!searchQuery.trim()) return items;
    
    const query = searchQuery.toLowerCase().trim();
    return items.filter(
      (item) =>
        item.name.toLowerCase().includes(query) ||
        item.category.toLowerCase().includes(query)
    );
  }, [searchQuery, activeTab]);

  // Calculate cart total
  const cartTotal = useMemo(() => {
    return cartItems.reduce((sum, item) => sum + item.price * item.quantity, 0);
  }, [cartItems]);

  // Add item to cart
  const handleAddToCart = (item: POSItem) => {
    setCartItems((prev) => {
      const existing = prev.find((p) => p.id === item.id);
      if (existing) {
        return prev.map((p) =>
          p.id === item.id ? { ...p, quantity: p.quantity + 1 } : p
        );
      } else {
        return [
          ...prev,
          {
            ...item,
            quantity: 1,
            type: activeTab === "products" ? "product" : "service",
          } as CartItem,
        ];
      }
    });
  };

  // Remove item from cart
  const handleRemoveFromCart = (id: string) => {
    setCartItems((prev) => prev.filter((item) => item.id !== id));
  };

  // Update item quantity
  const handleUpdateQuantity = (id: string, quantity: number) => {
    if (quantity < 1) {
      handleRemoveFromCart(id);
      return;
    }
    setCartItems((prev) =>
      prev.map((item) => (item.id === id ? { ...item, quantity } : item))
    );
    setEditingItem(null);
  };

  // Clear cart
  const handleClearCart = () => {
    setCartItems([]);
  };

  // Process payment
  const handlePayment = () => {
    // Simulate payment processing
    setTimeout(() => {
      setPaymentComplete(true);
      setTimeout(() => {
        setShowPaymentModal(false);
        setPaymentComplete(false);
        setCartItems([]);
      }, 2000);
    }, 1500);
  };

  // Get category color
  const getCategoryColor = (category: string) => {
    const colors: { [key: string]: string } = {
      "Skincare": "#885ABB",
      "Lip Care": "#C96EBE",
      "Aftercare": "#5AB7BB",
      "Professional": "#837EED",
      "Gift Sets": "#FFB74D",
      "Injectables": "#885ABB",
      "Dermal Fillers": "#C96EBE",
      "Facials": "#5AB7BB",
      "Peels": "#837EED",
      "Skin Treatments": "#4DB6AC",
      "Consultation": "#90A4AE",
    };
    return colors[category] || "#885ABB";
  };

  return (
    <div className="h-full flex flex-col overflow-hidden p-4 md:p-6">
      {/* Header */}
      <div className="flex flex-col md:flex-row items-center gap-3 mb-6 flex-shrink-0">
        <div className="relative w-full md:flex-1">
          <input
            type="text"
            placeholder={`Search ${activeTab}...`}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full border border-[#E5E0EB] rounded-lg py-3 pl-4 pr-10 text-[16px] font-medium text-[#402B69] placeholder:text-[#402B69]/60 focus:outline-none focus:ring-2 focus:ring-[#885ABB]/30 shadow-sm"
          />
          <Search className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 text-[#885ABB]" />
        </div>
        
        {/* Tab Buttons */}
        <div className="flex gap-2 w-full md:w-auto">
          <button
            onClick={() => setActiveTab("products")}
            className={`flex-1 md:flex-none px-6 py-3 rounded-lg font-semibold transition-all ${
              activeTab === "products"
                ? "bg-[#885ABB] text-white shadow-md"
                : "bg-white border border-[#E5E0EB] text-[#402B69] hover:border-[#885ABB]"
            }`}
          >
            Products
          </button>
          <button
            onClick={() => setActiveTab("services")}
            className={`flex-1 md:flex-none px-6 py-3 rounded-lg font-semibold transition-all ${
              activeTab === "services"
                ? "bg-[#885ABB] text-white shadow-md"
                : "bg-white border border-[#E5E0EB] text-[#402B69] hover:border-[#885ABB]"
            }`}
          >
            Services
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex flex-col lg:grid lg:grid-cols-3 gap-6 flex-1 overflow-hidden">
        {/* Products/Services Grid */}
        <div className="lg:col-span-2 order-2 lg:order-1 bg-white rounded-xl p-4 sm:p-6 overflow-y-auto shadow-sm border border-gray-100">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {filteredItems.map((item) => (
              <div
                key={item.id}
                onClick={() => handleAddToCart(item)}
                className="bg-white border-2 border-[#E5E0EB] rounded-xl cursor-pointer overflow-hidden hover:border-[#885ABB] hover:shadow-md transition-all group"
              >
                {item.image ? (
                  <div className="relative aspect-square">
                    <img
                      src={item.image}
                      alt={item.name}
                      className="h-full w-full object-cover"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/90 via-black/70 to-transparent p-3">
                      <h3 className="text-sm font-bold text-white truncate">
                        {item.name}
                      </h3>
                      <p className="text-lg font-extrabold text-white">
                        {currencySymbol}{item.price.toFixed(2)}
                      </p>
                    </div>
                  </div>
                ) : (
                  <div className="aspect-square p-4 flex flex-col justify-between">
                    <div
                      className="w-full h-2 rounded-full mb-3"
                      style={{ backgroundColor: getCategoryColor(item.category) }}
                    />
                    <div className="flex-1 flex flex-col justify-center">
                      <p className="text-xs text-gray-500 mb-1">{item.category}</p>
                      <h3 className="text-sm font-semibold text-[#402B69] line-clamp-2">
                        {item.name}
                      </h3>
                    </div>
                    <p className="text-lg font-bold text-[#885ABB] mt-2">
                      {item.price === 0 ? "FREE" : `${currencySymbol}${item.price.toFixed(2)}`}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
          
          {filteredItems.length === 0 && (
            <div className="text-center py-12 text-gray-500">
              <p className="text-lg">No {activeTab} found</p>
              <p className="text-sm mt-2">Try a different search term</p>
            </div>
          )}
        </div>

        {/* Cart */}
        <div className="lg:col-span-1 order-1 lg:order-2 bg-white rounded-xl p-4 sm:p-6 flex flex-col overflow-hidden shadow-sm border border-gray-100">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-lg font-bold text-[#402B69] flex items-center gap-2">
              <ShoppingCart className="w-5 h-5 text-[#885ABB]" />
              Cart
            </h2>
            {cartItems.length > 0 && (
              <button
                onClick={handleClearCart}
                className="text-sm text-red-500 hover:text-red-600 font-medium"
              >
                Clear All
              </button>
            )}
          </div>

          {/* Cart Items */}
          <div className="flex-1 overflow-y-auto space-y-3 mb-4 pr-2">
            {cartItems.length === 0 ? (
              <div className="text-center py-8 text-gray-400">
                <ShoppingCart className="w-12 h-12 mx-auto mb-3 opacity-30" />
                <p className="text-sm">Cart is empty</p>
                <p className="text-xs mt-1">Click on items to add them</p>
              </div>
            ) : (
              cartItems.map((item) => (
                <div
                  key={item.id}
                  className="flex items-center justify-between bg-gray-50 rounded-lg p-3 group"
                >
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2">
                      <span
                        className="w-2 h-2 rounded-full flex-shrink-0"
                        style={{ backgroundColor: getCategoryColor(item.category) }}
                      />
                      <p className="text-sm font-medium text-[#402B69] truncate">
                        {item.name}
                      </p>
                    </div>
                    <p className="text-xs text-gray-500 ml-4">
                      {item.type === "product" ? "Product" : "Service"} • {currencySymbol}{item.price.toFixed(2)} × {item.quantity}
                    </p>
                  </div>
                  
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-bold text-[#402B69]">
                      {currencySymbol}{(item.price * item.quantity).toFixed(2)}
                    </span>
                    
                    <div className="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          setEditingItem(item.id);
                          setEditQuantity(item.quantity);
                        }}
                        className="p-1 hover:bg-[#885ABB]/10 rounded text-[#885ABB]"
                      >
                        <Pencil className="w-4 h-4" />
                      </button>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handleRemoveFromCart(item.id);
                        }}
                        className="p-1 hover:bg-red-50 rounded text-red-500"
                      >
                        <Trash2 className="w-4 h-4" />
                      </button>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>

          {/* Cart Footer */}
          <div className="flex-shrink-0 border-t border-[#E5E0EB] pt-4">
            <div className="flex justify-between items-center mb-4">
              <span className="text-xl font-semibold text-[#402B69]">Total</span>
              <span className="text-2xl font-bold text-[#885ABB]">
                {currencySymbol}{cartTotal.toFixed(2)}
              </span>
            </div>
            
            <button
              onClick={() => setShowPaymentModal(true)}
              disabled={cartItems.length === 0}
              className="w-full bg-[#885ABB] text-white rounded-lg py-3 font-bold hover:bg-[#6f3fa8] transition disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
            >
              <CreditCard className="w-5 h-5" />
              PAY NOW
            </button>
          </div>
        </div>
      </div>

      {/* Edit Quantity Modal */}
      {editingItem && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl p-6 w-full max-w-sm shadow-xl">
            <h3 className="text-lg font-bold text-[#402B69] mb-4">Edit Quantity</h3>
            <div className="flex items-center justify-center gap-4 mb-6">
              <button
                onClick={() => setEditQuantity(Math.max(1, editQuantity - 1))}
                className="w-12 h-12 rounded-full bg-gray-100 text-[#402B69] font-bold text-xl hover:bg-gray-200"
              >
                -
              </button>
              <span className="text-3xl font-bold text-[#885ABB] w-16 text-center">
                {editQuantity}
              </span>
              <button
                onClick={() => setEditQuantity(editQuantity + 1)}
                className="w-12 h-12 rounded-full bg-gray-100 text-[#402B69] font-bold text-xl hover:bg-gray-200"
              >
                +
              </button>
            </div>
            <div className="flex gap-3">
              <button
                onClick={() => setEditingItem(null)}
                className="flex-1 px-4 py-2 border border-gray-200 rounded-lg text-gray-600 hover:bg-gray-50"
              >
                Cancel
              </button>
              <button
                onClick={() => handleUpdateQuantity(editingItem, editQuantity)}
                className="flex-1 px-4 py-2 bg-[#885ABB] text-white rounded-lg hover:bg-[#6f3fa8]"
              >
                Update
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Payment Modal */}
      {showPaymentModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl p-6 w-full max-w-md shadow-xl">
            {paymentComplete ? (
              <div className="text-center py-8">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Check className="w-8 h-8 text-green-600" />
                </div>
                <h3 className="text-xl font-bold text-[#402B69] mb-2">Payment Successful!</h3>
                <p className="text-gray-500">Transaction completed</p>
              </div>
            ) : (
              <>
                <div className="flex items-center justify-between mb-6">
                  <h3 className="text-xl font-bold text-[#402B69]">Payment</h3>
                  <button
                    onClick={() => setShowPaymentModal(false)}
                    className="p-2 hover:bg-gray-100 rounded-lg"
                  >
                    <X className="w-5 h-5 text-gray-500" />
                  </button>
                </div>

                {/* Order Summary */}
                <div className="bg-gray-50 rounded-lg p-4 mb-6">
                  <h4 className="font-semibold text-[#402B69] mb-3">Order Summary</h4>
                  <div className="space-y-2 max-h-40 overflow-y-auto">
                    {cartItems.map((item) => (
                      <div key={item.id} className="flex justify-between text-sm">
                        <span className="text-gray-600">
                          {item.name} × {item.quantity}
                        </span>
                        <span className="font-medium text-[#402B69]">
                          {currencySymbol}{(item.price * item.quantity).toFixed(2)}
                        </span>
                      </div>
                    ))}
                  </div>
                  <div className="border-t border-gray-200 mt-3 pt-3 flex justify-between">
                    <span className="font-bold text-[#402B69]">Total</span>
                    <span className="font-bold text-[#885ABB] text-lg">
                      {currencySymbol}{cartTotal.toFixed(2)}
                    </span>
                  </div>
                </div>

                {/* Payment Method */}
                <div className="mb-6">
                  <h4 className="font-semibold text-[#402B69] mb-3">Payment Method</h4>
                  <div className="grid grid-cols-3 gap-3">
                    {(["card", "cash", "split"] as const).map((method) => (
                      <button
                        key={method}
                        onClick={() => setPaymentMethod(method)}
                        className={`py-3 px-4 rounded-lg border-2 font-medium capitalize transition-all ${
                          paymentMethod === method
                            ? "border-[#885ABB] bg-[#885ABB]/10 text-[#885ABB]"
                            : "border-gray-200 text-gray-600 hover:border-[#885ABB]/50"
                        }`}
                      >
                        {method}
                      </button>
                    ))}
                  </div>
                </div>

                {/* Pay Button */}
                <button
                  onClick={handlePayment}
                  className="w-full bg-[#885ABB] text-white rounded-lg py-4 font-bold text-lg hover:bg-[#6f3fa8] transition flex items-center justify-center gap-2"
                >
                  <CreditCard className="w-5 h-5" />
                  Pay {currencySymbol}{cartTotal.toFixed(2)}
                </button>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default AestheticPOS;

